import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class WebViewService {

  public webViewMessage = new Subject<any>();

  constructor() {
    window?.chrome?.webview?.addEventListener('message', event => {
      this.webViewMessage.next(event.data);
    });
  }

  public postMessage(message: any) {
    console.log(" aaaaaa   "   +message)

    window?.chrome?.webview?.postMessage(message);
    console.log(" bbbbb   "   +message)

  }
}

// add chrome to the Window context so typescript stops complaining
declare global {
  interface Window {
    chrome: any;
  }
}